(function () {
  const initStickyToc = () => {
    const article = document.querySelector('[data-blog-article]');
    if (!article) return;

    const content = article.querySelector('[data-blog-content]');
    const tocContainer = article.querySelector('[data-toc-container]');
    const tocList = article.querySelector('[data-toc-list]');
    if (!content || !tocContainer || !tocList) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter(
      (heading) => heading.textContent && heading.textContent.trim().length > 0
    );
    if (!headings.length) return;

    const slugCounts = {};

    headings.forEach((heading) => {
      const rawText = heading.textContent.trim();
      let baseSlug = rawText
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

      if (!baseSlug) {
        baseSlug = `section-${Math.random().toString(36).slice(2, 8)}`;
      }

      slugCounts[baseSlug] = (slugCounts[baseSlug] || 0) + 1;
      const suffix = slugCounts[baseSlug] > 1 ? `-${slugCounts[baseSlug]}` : '';
      const anchorId = `${baseSlug}${suffix}`;

      if (!heading.id) {
        heading.id = anchorId;
      }

      const li = document.createElement('li');
      if (heading.tagName.toLowerCase() === 'h3') {
        li.className = 'ml-3';
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.className = 'text-gray-600 hover:text-gray-900 transition-colors';
      link.textContent = rawText;

      li.appendChild(link);
      tocList.appendChild(li);
    });

    tocContainer.hidden = false;

    const links = Array.from(tocList.querySelectorAll('a'));
    const headingMap = headings.map((heading) => ({
      id: heading.id,
      top: heading.getBoundingClientRect().top + window.scrollY,
    }));

    const setActive = () => {
      const scrollPosition = window.scrollY + 140;
      let activeId = '';

      for (const item of headingMap) {
        if (item.top <= scrollPosition) {
          activeId = item.id;
        } else {
          break;
        }
      }

      links.forEach((link) => {
        const isActive = activeId && link.getAttribute('href') === `#${activeId}`;
        link.classList.toggle('font-semibold', Boolean(isActive));
        link.classList.toggle('text-gray-900', Boolean(isActive));
        link.classList.toggle('text-gray-600', !isActive);
      });
    };

    setActive();
    window.addEventListener('scroll', setActive, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyToc);
  } else {
    initStickyToc();
  }
})();
